import React, { ReactNode, useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { pathnameWithParameters } from '../../utils/location';
import { Header } from '../header';
import { NavHeader } from '../nav-header';
import { Page } from '../page';
import './index.scss';

type HeaderWithHelpCommonProps = {
  children: ReactNode;
  name: string;
  headerTitle?: string;
  helpTitle: string;
  headerSubtitle?: string;
  noBackButton?: boolean;
  helpContent?: ReactNode;
  hidden?: boolean;
};

type MainHeaderProps = HeaderWithHelpCommonProps & {
  kind: 'main';
  handleClose: () => void;
};

type SubHeaderProps = Omit<HeaderWithHelpCommonProps, 'kind'> & {
  kind: 'sub-header';
};

type HeaderWithHelpProps = MainHeaderProps | SubHeaderProps;

const HeaderWithHelp: React.FC<HeaderWithHelpProps> = (props) => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const { children, headerTitle, helpTitle, headerSubtitle, helpContent, hidden } = props;
  const { t } = useTranslation('common');
  const [helpVisible, setHelpVisible] = useState<string>('');

  useEffect(() => {
    const help = new URLSearchParams(search).get('help');
    setHelpVisible(help || '');
  }, [search]);

  const openHelpContent = () => {
    navigate(pathnameWithParameters(pathname, search, { key: 'help', value: props.name }));
  };

  const closeHelpContent = () => navigate(-1);

  return (
    <>
      {helpVisible !== props.name ? (
        <Page
          className="header-with-help"
          {...(props.kind === 'sub-header' ? { containerClassName: 'no-padding' } : {})}
          header={
            <>
              <>
                {props.kind === 'main' && <NavHeader onClick={props.handleClose} noBackButton={props.noBackButton} />}
                <Header title={headerTitle}>
                  {!hidden && (
                    <button className="header-with-help__icon" type="button" onClick={openHelpContent}>
                      ?
                    </button>
                  )}
                </Header>
              </>
              {headerSubtitle && (
                <h5 className="header__title-subtitle m-b-24 header__title-subtitle--negative-margin">
                  {headerSubtitle}
                </h5>
              )}
            </>
          }
        >
          {children}
        </Page>
      ) : (
        <Page
          kind="above"
          header={
            <>
              <NavHeader onClick={closeHelpContent} />
              <Header title={helpTitle} isUnderline />
            </>
          }
        >
          {helpContent || <Trans>{t('dialogWorkInProgress.header')}</Trans>}
        </Page>
      )}
    </>
  );
};

export default HeaderWithHelp;
